const config = {
	apiBaseUrl:
		process.env.REACT_APP_BASE_URL || "https://api.prod.trackyourimpact.io",
	googleMapsApiKey:
		process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
};

export default config;
